import {Controller} from "@hotwired/stimulus";
import {MXInvoiceValidation} from "../payments/invoice_validations/mx_invoice_validation";
import {COInvoiceValidation} from "../payments/invoice_validations/co_invoice_validation";
import {ClInvoiceValidation} from "../payments/invoice_validations/cl_invoice_validation";

/**
 * Controller use by the Studio to upload the invoice
 */
export default class UploadInvoiceFormController extends Controller {
  static values = {
    country: String,
    paymentAmount: Number,
    formattedPaymentAmount: String,
  }

  static targets = [
    "receiptTypeInput", 'fiscalIdInput', 'invoicePdfInput', 'invoiceXmlInput',
    "xmlError", "submitBtn", "xmlSuccess", "pdfSuccess"
  ]

  initialize() {
    console.debug("Upload Invoice Form ", {
      country: this.countryValue,
      paymentAmount: this.paymentAmountValue,
      formattedPaymentAmount: this.formattedPaymentAmountValue,
    })

    this.xmlError = undefined;
  }

  submitSearchFormOnSuccess(event) {
    if (event.detail.success) {
      document.querySelector("#search_form").requestSubmit();
    }
  }

  getInvoiceValidation(oDOM) {
    switch (this.countryValue) {
      case "mx": {
        return new MXInvoiceValidation(
          oDOM,
          this.paymentAmountValue,
          this.formattedPaymentAmountValue
        );
      }

      case "co": {
        return new COInvoiceValidation(
          oDOM,
          this.paymentAmountValue,
          this.formattedPaymentAmountValue
        );
      }

      case "cl": {
        return new ClInvoiceValidation(
          oDOM,
          this.paymentAmountValue,
          this.formattedPaymentAmountValue
        );
      }

      default: {
        return undefined;
      }
    }
  }

  pdfUploaded(event) {
    this.pdfSuccessTarget.classList.remove("d-none");
  }

  xmlUploaded(event) {
    console.log("XML uploaded", event);
    this.clearError();
    this.readXMLFile(event.target.files);
  }

  readXMLFile(files) {
    if (files.length === 0) {
      this.xmlError = undefined;
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const fileReader = e.target;
      this.xmlError = this.validateXML(fileReader.result);
      console.warn("=> Result XML", this.xmlError);


      if (this.xmlError.error) {
        this.xmlSuccessTarget.classList.add("d-none");
        this.submitBtnTarget.setAttribute("disabled", "disabled");
        this.displayError();
        return;
      }

      this.submitBtnTarget.removeAttribute("disabled");
      this.xmlSuccessTarget.classList.remove("d-none");
    };

    reader.readAsText(files[0]);
  }

  validateXML(xmlString) {
    console.warn(xmlString);

    const oParser = new DOMParser();
    const oDOM = oParser.parseFromString(xmlString, "application/xml");
    if (oDOM.documentElement.nodeName === "parsererror") {
      return {error: true, message: "Archivo inválido"};
    }
    const validation = this.getInvoiceValidation(oDOM);

    if (validation) {
      this.receiptTypeInputTarget.value = validation.receiptType();
      this.fiscalIdInputTarget.value = validation.fiscalID;
      return validation.validate();
    } else {
      return {error: true, message: `País ${this.countryValue} no soportado`};
    }
  }

  clearError() {
    this.xmlErrorTarget.innerHTML = "";
    this.xmlErrorTarget.classList.remove("d-block");
    this.invoiceXmlInputTarget.classList.remove("is-invalid");
  }

  displayError() {
    this.xmlErrorTarget.innerHTML = this.xmlError.message;
    this.xmlErrorTarget.classList.add("d-block");
    this.invoiceXmlInputTarget.classList.add("is-invalid");
    this.invoiceXmlInputTarget.value = "";
  }
}
